import { Body2, Box, Grid, GridItem, Label2 } from '@sainsburys-tech/fable'
import React from 'react'

import { TempCheckFor } from '../../enums/TempCheckFor'
import {
  getInstructionDescription,
  getInstructionTitle,
} from '../../utils/CounterInstructionMessages'

interface ICounterInstructionProps {
  isFirstCheck: boolean
  isInputMode: boolean
}

const CounterInstruction = (props: ICounterInstructionProps) => {
  const isInputMode = props.isInputMode

  return (
    <Box
      className='c-counter-instruction-content'
      data-testid='counter-instruction'
      backgroundColor='secondary'
    >
      <Grid cols={12} gap='md'>
        <GridItem colSpan={12}>
          <div className='c-batch-card'>
            <Label2 style={{ marginBottom: '8px' }}>
              {getInstructionTitle(
                props.isFirstCheck
                  ? TempCheckFor.FirstAir
                  : TempCheckFor.Regular,
              )}
            </Label2>
          </div>
          {isInputMode && (
            <div data-testid='counter-instruction-message'>
              <Body2>
                {getInstructionDescription(
                  props.isFirstCheck
                    ? TempCheckFor.FirstAir
                    : TempCheckFor.Regular,
                )}
              </Body2>
            </div>
          )}
        </GridItem>
      </Grid>
    </Box>
  )
}

export default CounterInstruction
